import React from 'react';
// import { Button, Input } from 'antd';
// import css from './css.less';
const Test = (props) => {
  const { children } = props;
  return (
    <div>
      LoginLayout
      {children}
    </div>
  );
};
export default Test;
